export default __webpack_public_path__ + "static/media/romerne.e5a94544.jpg";